import { render, staticRenderFns } from "./service-module.vue?vue&type=template&id=4ec616ca&scoped=true&"
import script from "./service-module.vue?vue&type=script&lang=js&"
export * from "./service-module.vue?vue&type=script&lang=js&"
import style0 from "./service-module.vue?vue&type=style&index=0&id=4ec616ca&prod&scoped=true&lang=css&"
import style1 from "./service-module.vue?vue&type=style&index=1&id=4ec616ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec616ca",
  null
  
)

export default component.exports